import React from 'react';
import 'plyr/dist/plyr.css';
import clsx from 'clsx';

import { useCompleteVideo } from '../../hooks';
import { usePlurPlayer } from './usePlurPlayer';

export type VideoPlayerProps = {
  source: string;
  className?: string;
  onPlay?: () => void;
  onComplete?: () => void;
};

const getYouTubeVideoId = (url: string): string | null => {
  const match = url.match(
    /(?:youtube\.com\/.*[?&]v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/)([a-zA-Z0-9_-]{11})/
  );
  return match ? match[1] : null;
};

const YoutubePlayer: React.FC<VideoPlayerProps> = ({
  source,
  className,
  onPlay,
  onComplete,
}) => {
  const videoId = getYouTubeVideoId(source);

  const { containerRef, playerInstanceRef } = usePlurPlayer({
    videoId,
    onPlay: () => {
      onPlay?.();
      startTrackingProgress();
    },
    onStop: () => {
      stopTrackingProgress?.();
    },
  });

  const [startTrackingProgress, stopTrackingProgress] = useCompleteVideo(
    playerInstanceRef,
    onComplete
  );

  return (
    <div
      ref={containerRef}
      className={clsx(className, 'overflow-hidden')}
      style={{
        width: '100%',
        aspectRatio: '16/9',
        pointerEvents: 'auto',
      }}
    />
  );
};

export default YoutubePlayer;
